module.exports = __webpack_public_path__ + "static/media/Niveau_elN15_3_988931.2a2673cf.png";